import { useQuery } from '@apollo/client'
import { Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router-dom'

import SuccessfulReceiptVector from '../../assets/images/SuccessfulReceipt.png'
import AdotelSkeleton from '../../components/AdotelSkeleton'
import { WALLET_QUERY } from '../../graphql/wallet'
import { PROFORMA_QUERY } from '../../graphql/walletProforma'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import ActionButtons from './ActionButtons'
import PaymentDetails from './PaymentDetails'
import TransactionDetails from './TransactionDetails'
import { useStyles } from './styles/index.styles'

// type Props = {}

const WalletProformaInvoiceReceipt = () => {
  const classes = useStyles()
  const theme = useTheme()

  const params = useParams<{ walletId: string; proformaId: string }>()
  const { data: wallet, loading: loadingForwallet } = useQuery<{
    wallet: Wallet
  }>(WALLET_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      walletID: params.walletId
    }
  })

  const { data: proforma, loading: loadingForProformas } = useQuery<{
    proforma: Proforma
  }>(PROFORMA_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      proformaID: params.proformaId
    }
  })

  return !loadingForProformas && proforma && !loadingForwallet && wallet ? (
    <div className={classes.root}>
      <div className={classes.iconContainer}>
        <img
          src={SuccessfulReceiptVector}
          alt={getTranslate('successfulVector')}
        />
      </div>

      <Typography variant="h4" gutterBottom>
        {getTranslate('Congratulations, Your payment is complete!')}
      </Typography>

      <div className={classes.section}>
        <Typography variant="body1" gutterBottom>
          {getTranslate('Transaction Details')}
        </Typography>
        <TransactionDetails
          proforma={proforma.proforma}
          wallet={wallet.wallet}
        />
      </div>
      {/* TODO: make this work later */}
      <Typography className={classes.link}>
        {getTranslate('Click to see all transactions')}
      </Typography>

      <div className={classes.section}>
        <Typography variant="body1" gutterBottom>
          {getTranslate('Payment Details')}
        </Typography>
        <PaymentDetails proforma={proforma.proforma} wallet={wallet.wallet} />
      </div>

      <div className={classes.section}>
        <ActionButtons proforma={proforma.proforma} wallet={wallet.wallet} />
      </div>
    </div>
  ) : (
    <AdotelSkeleton
      open={loadingForProformas}
      circlesColor={theme.palette.primary.main}
      numberOfCircles={4}
    />
  )
}

export default WalletProformaInvoiceReceipt
